import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const BUSINESS = {
  name: "Laredo Backflow LLC",
  phone: "956-942-5496",
  phoneHref: "tel:+19569425496",
  email: "gabriel@laredobackflowllc.com",
  emailHref: "mailto:gabriel@laredobackflowllc.com",
  areas: ["Laredo", "Zapata", "Cotulla", "Freer", "McAllen", "Brownsville"],
};

export const api = axios.create({ baseURL: API });
